// extracted by mini-css-extract-plugin
module.exports = {"MediaPreview":"MediaPreview_MediaPreview__3wMjY","errorDisplay":"MediaPreview_errorDisplay__-2Yp-","coverView":"MediaPreview_coverView__27izP"};